import $ from "jquery";

export default {
	finalize() {

		$('#loader').hide();
		
		var filter = new Array();
		var ex = [];
		var ex_values = [];
		var people_value;

		$('.filter-item').on('click', function() {
			var $this = $(this);

			if($this.data('type') === 'people') {
				people_value = $this.data('slug');
			}

			filter.push($this.data('type'));
			var filter_types = [];

			//Remove duplicates
			$.each(filter, function(i, el){
				if($.inArray(el, filter_types) === -1) filter_types.push(el);
			});

			if($this.hasClass('selected')) {
				$this.removeClass('selected');

				if($this.data('type') === 'experience') {
					var ex_value = $this.data('slug');
					if($.inArray(ex_values, ex_value)) {
						for( var i = 0; i < ex_values.length; i++){ 		
							if ( ex_values[i] === ex_value) { 
								ex_values.splice(i, 1); 
								i--; 
							}
						}
					}
				}

				if($this.data('type') === 'people') {
					if(people_value === $this.data('slug')) {
						if($('.filter-item.people.selected')) {
							people_value = $('.filter-item.people.selected').data('slug');
						} else {
							people_value = [];
						}
					}
				}

			} else {
				$this.addClass('selected');

				if($this.data('type') === 'experience') {
					var ex_value = $this.data('slug');
					ex_values.push(ex_value);
				}
			}

			$.ajax({
				type: 'POST',
				url : ajax_vars.ajaxurl,
				dataType: 'html',
				data: {
					action: 'filter_facilities',
					filter_types: filter_types,
					ex_values: ex_values,
					p_value: people_value,
				},
				beforeSend: function() {
					$('#loader').show();
				},
				complete: function(){
					$('#loader').hide();
				},
				success: function(res) {
					$('.list-facilities').html(res);
				}
			})
		});

		//form
		$('.toggle-form').on('click', function() {
			$('.conference-form').toggleClass('hidden');
			$('.conference-form').toggleClass('lg:hidden');
			sessionStorage.setItem('form-open', "true");
		})

		$('.toggle-form.close').on('click', function(){
			sessionStorage.setItem('form-open', "false");
		})

		if (sessionStorage.getItem('form-open') && sessionStorage.getItem('form-open') === "true") {
			$('.conference-form').toggleClass('hidden');
			$('.conference-form').toggleClass('lg:hidden');
		}
	}
}